/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  GroupTimeseriesResponse,
  TelemetryChannelAggregatesParams,
  TelemetryChannelTimeseriesParams,
  TelemetryGroupTimeseriesParams,
  TimeseriesPoint
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get telemetry timeseries for a single channel
 */
export const telemetryChannelTimeseries = (
    channelID: number,
    params: TelemetryChannelTimeseriesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TimeseriesPoint[]>(
      {url: `/api/telemetry/channels/${channelID}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getTelemetryChannelTimeseriesQueryKey = (channelID?: number,
    params?: TelemetryChannelTimeseriesParams,) => {
    return [
    `/api/telemetry/channels/${channelID}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTelemetryChannelTimeseriesQueryOptions = <TData = Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError = ErrorResponse>(channelID: number,
    params: TelemetryChannelTimeseriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelemetryChannelTimeseriesQueryKey(channelID,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof telemetryChannelTimeseries>>> = ({ signal }) => telemetryChannelTimeseries(channelID,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(channelID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TelemetryChannelTimeseriesQueryResult = NonNullable<Awaited<ReturnType<typeof telemetryChannelTimeseries>>>
export type TelemetryChannelTimeseriesQueryError = ErrorResponse


export function useTelemetryChannelTimeseries<TData = Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError = ErrorResponse>(
 channelID: number,
    params: TelemetryChannelTimeseriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof telemetryChannelTimeseries>>,
          TError,
          Awaited<ReturnType<typeof telemetryChannelTimeseries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelemetryChannelTimeseries<TData = Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError = ErrorResponse>(
 channelID: number,
    params: TelemetryChannelTimeseriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof telemetryChannelTimeseries>>,
          TError,
          Awaited<ReturnType<typeof telemetryChannelTimeseries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelemetryChannelTimeseries<TData = Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError = ErrorResponse>(
 channelID: number,
    params: TelemetryChannelTimeseriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get telemetry timeseries for a single channel
 */

export function useTelemetryChannelTimeseries<TData = Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError = ErrorResponse>(
 channelID: number,
    params: TelemetryChannelTimeseriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelTimeseries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTelemetryChannelTimeseriesQueryOptions(channelID,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get aggregated telemetry with custom step
 */
export const telemetryChannelAggregates = (
    channelID: number,
    params: TelemetryChannelAggregatesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TimeseriesPoint[]>(
      {url: `/api/telemetry/channels/${channelID}/aggregates`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getTelemetryChannelAggregatesQueryKey = (channelID?: number,
    params?: TelemetryChannelAggregatesParams,) => {
    return [
    `/api/telemetry/channels/${channelID}/aggregates`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTelemetryChannelAggregatesQueryOptions = <TData = Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError = ErrorResponse>(channelID: number,
    params: TelemetryChannelAggregatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelemetryChannelAggregatesQueryKey(channelID,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof telemetryChannelAggregates>>> = ({ signal }) => telemetryChannelAggregates(channelID,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(channelID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TelemetryChannelAggregatesQueryResult = NonNullable<Awaited<ReturnType<typeof telemetryChannelAggregates>>>
export type TelemetryChannelAggregatesQueryError = ErrorResponse


export function useTelemetryChannelAggregates<TData = Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError = ErrorResponse>(
 channelID: number,
    params: TelemetryChannelAggregatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof telemetryChannelAggregates>>,
          TError,
          Awaited<ReturnType<typeof telemetryChannelAggregates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelemetryChannelAggregates<TData = Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError = ErrorResponse>(
 channelID: number,
    params: TelemetryChannelAggregatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof telemetryChannelAggregates>>,
          TError,
          Awaited<ReturnType<typeof telemetryChannelAggregates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelemetryChannelAggregates<TData = Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError = ErrorResponse>(
 channelID: number,
    params: TelemetryChannelAggregatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get aggregated telemetry with custom step
 */

export function useTelemetryChannelAggregates<TData = Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError = ErrorResponse>(
 channelID: number,
    params: TelemetryChannelAggregatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryChannelAggregates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTelemetryChannelAggregatesQueryOptions(channelID,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetches and aggregates telemetry data for all channels in a group.

**Aggregation Logic:**
- For each (timestamp, interval) pair across all channels
- `sum = Σ(channel_value × channel_sign)`
- `avg = sum / channels_with_data`
- `min/max` = minimum/maximum individual channel values

**Limits:**
- Maximum 1000 channels per group (truncated with warning)
- Maximum period: 366 days

 * @summary Get aggregated telemetry for a group of channels
 */
export const telemetryGroupTimeseries = (
    groupID: string,
    params: TelemetryGroupTimeseriesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GroupTimeseriesResponse>(
      {url: `/api/telemetry/groups/${groupID}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getTelemetryGroupTimeseriesQueryKey = (groupID?: string,
    params?: TelemetryGroupTimeseriesParams,) => {
    return [
    `/api/telemetry/groups/${groupID}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTelemetryGroupTimeseriesQueryOptions = <TData = Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError = ErrorResponse>(groupID: string,
    params: TelemetryGroupTimeseriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelemetryGroupTimeseriesQueryKey(groupID,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof telemetryGroupTimeseries>>> = ({ signal }) => telemetryGroupTimeseries(groupID,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(groupID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TelemetryGroupTimeseriesQueryResult = NonNullable<Awaited<ReturnType<typeof telemetryGroupTimeseries>>>
export type TelemetryGroupTimeseriesQueryError = ErrorResponse


export function useTelemetryGroupTimeseries<TData = Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError = ErrorResponse>(
 groupID: string,
    params: TelemetryGroupTimeseriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof telemetryGroupTimeseries>>,
          TError,
          Awaited<ReturnType<typeof telemetryGroupTimeseries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelemetryGroupTimeseries<TData = Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError = ErrorResponse>(
 groupID: string,
    params: TelemetryGroupTimeseriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof telemetryGroupTimeseries>>,
          TError,
          Awaited<ReturnType<typeof telemetryGroupTimeseries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelemetryGroupTimeseries<TData = Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError = ErrorResponse>(
 groupID: string,
    params: TelemetryGroupTimeseriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get aggregated telemetry for a group of channels
 */

export function useTelemetryGroupTimeseries<TData = Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError = ErrorResponse>(
 groupID: string,
    params: TelemetryGroupTimeseriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telemetryGroupTimeseries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTelemetryGroupTimeseriesQueryOptions(groupID,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




